import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import * as React from 'react';
import { Images } from '../assets';
import { ClaimErrorContentProps } from '../interface';
import ClaimContainer from './ClaimContainer';

export interface ClaimErrorContainerProps {
  error?: string;
  content?: ClaimErrorContentProps;
  logoUrl?: string;
  onClickDisconnectWallet: () => void;
}

const ClaimErrorContainer = ({ content, logoUrl, error, onClickDisconnectWallet }: ClaimErrorContainerProps) => {
  return (
    <Box>
      <ClaimContainer
        image={logoUrl || Images.MOJITO_LOGO}
        title={content?.title || 'Claim Member Pass'}
        description={error || ''}
        error={error}
      />
      <Stack
        direction="column"
        gap="16px"
        sx={{
          marginTop: '20px'
        }}
      >
        <Button
          sx={{
            width: '100%'
          }}
          onClick={onClickDisconnectWallet}
        >
          Connect a Different Wallet
        </Button>
      </Stack>
    </Box>
  );
};

export default ClaimErrorContainer;
